import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import { dateColTemplate, dowColTemplate, requiredColTemplate, formatNumberTemplate, availableWithVCapTemplate } from './groupIQHelper'
import {
    Checkbox,
    Popover
} from '@mui/material/';
import moment from 'moment';
import { Grid } from 'smart-webcomponents-react/grid';
import 'smart-webcomponents-react/source/styles/smart.default.css';
import NotesPopup from '../DynamicTable/NotesPopup';
import EventsPopup from '../DynamicTable/EventsPopup';
import VCapIndicator from '../DynamicTable/VCapIndicator';
import {
    convertToPercent, dateFormat, deepCopy, dateDiff, isDateInRange, yearDiff, getDemandImpactColor
} from "../../app/util";
import './groupIQ.css';
import { useSelector } from "react-redux";
function RoomBlock({ Smart, arrivalDate, departureDate, otbRmType, totalCapacity, variableCapacityEnabled, collectTabData, tabData, footerData }) {
    const [revenueModifier, setRevenueModifier] = useState({});
    const gridRef = useRef(null);
    const dateValueRef = useRef(null);
    const vcapDataRef = useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { app } = useSelector((state) => state);
    const { app_state, ui_state } = app.current_state;
    const { room_settings, notes, avgImpactData, eventList } = app_state;
    const groupIQNew = useRef([]);

    const [gridHeight, setGridHeight] = useState(null);

    const initialColumns = [
        {
            label: 'Date',
            dataField: 'date',
            columnGroup: 'staydates',
            allowEdit: false,
            allowResize: false,
            freeze: 'near',
            width: 90,
            labelTemplate: '<div id="date-dow">Date</div>',
            template: dateColTemplate(dateFormat, notes),
        },
        {
            label: 'DOW',
            dataField: 'dow',
            columnGroup: 'staydates',
            allowEdit: false,
            allowResize: false,
            freeze: 'near',
            width: 90,
            labelTemplate: '<div id="date-dow">DOW</div>',
            template: dowColTemplate(dateFormat, avgImpactData, getDemandImpactColor, eventList, isDateInRange),
        },
        {
            label: 'Available',
            labelTemplate: `<div id="secondary-header">
                Available 
                ${variableCapacityEnabled && variableCapacityEnabled === true ? '<div class="variable-capacity">•OOO/OOS</div>' : ''}
            </div>`,
            dataField: 'runOfHouse-available',
            columnGroup: 'runOfHouse',
            allowEdit: false,
            minWidth: 120,
            template: availableWithVCapTemplate(variableCapacityEnabled),
        },
        {
            label: 'Required',
            dataField: 'runOfHouse-required',
            minWidth: 120,
            columnGroup: 'runOfHouse',
            labelTemplate: '<div id="secondary-header">Required</div>',
            template: requiredColTemplate('cell-right-border'),
        },
        {
            label: 'Available',
            labelTemplate: '<div id="secondary-header">Available</div>',
            dataField: 'total-available',
            columnGroup: 'total',
            freeze: 'far',
            width: 90,
            allowEdit: false,
            template: formatNumberTemplate(),
        },
        {
            label: 'Required',
            labelTemplate: '<div id="secondary-header">Required</div>',
            dataField: 'total-required',
            columnGroup: 'total',
            freeze: 'far',
            width: 90,
            allowEdit: false,
            template: formatNumberTemplate(),
        },
    ]
    const nonRemovableColumnGroups = [
        {
            label: dateFormat(arrivalDate, "YYYY"),
            name: 'staydates',
        },
        {
            label: 'Total',
            name: 'total',
        }
    ];
    const removableColumnGroups = [];

    const columnNames = ["runOfHouse"];

    room_settings.forEach(rm => {
        columnNames.push(rm.room_code)
    })

    columnNames.forEach(col => {
        let label = (col === "runOfHouse") ? "Run of House" : col;
        removableColumnGroups.push({
            label,
            name: col
        })
    })

    const columnsNew = useRef(initialColumns);
    const columnGroupsNew = useRef([...nonRemovableColumnGroups, removableColumnGroups[0]]);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState(columnGroupsNew.current.map(group => group.name));

    useEffect(() => {
        if (tabData.current.dataSource.length === 0) {
            setupRoomblockData();
            setRevenueModifier(footerData);
            const newLabel = yearDiff(arrivalDate, departureDate);
            columnGroupsNew.current[0].label = newLabel;
            const primaryHeader = document.getElementById('primary-header');
            if (primaryHeader) {
                primaryHeader.querySelector('div').textContent = newLabel;
            }
        }
        else {

            setRevenueModifier(tabData.current.footerField)

            let visibleItem = tabData.current.columnGroupObjs.map(item => item.name);
            setSelectedGroups(visibleItem)

            columnGroupsNew.current = [...tabData.current.columnGroupObjs]
            columnsNew.current = [...tabData.current.columnObjs]

            gridRef.current.dataSource = tabData.current.dataSource;
        }
    }, [otbRmType])

    useEffect(() => {
        const handleOpenDropdown = () => {
            toggleDropdown();
            setTimeout(() => {
                handleScrollToEnd();
            }, 0);
        };

        document.addEventListener('openDropdown', handleOpenDropdown);

        return () => {
            document.removeEventListener('openDropdown', handleOpenDropdown);
        };
    }, []);


    useEffect(() => {
        const handleRemoveColumnGroup = (event) => {
            removeColumnGroup(event.detail);
        };
        document.addEventListener('removeColumnGroup', handleRemoveColumnGroup);

        return () => {
            document.removeEventListener('removeColumnGroup', handleRemoveColumnGroup);
        };
    }, [removableColumnGroups]);

    const setTableHeight = () => {
        let windowHeight = window.innerHeight;
        setGridHeight(windowHeight - 300);
    };

    useEffect(() => {
        setTableHeight();
        window.addEventListener("resize", setTableHeight);

        return () => {
            window.removeEventListener("resize", setTableHeight);
        };
    }, [groupIQNew.current, arrivalDate, departureDate]);



    const calculateTotalGroupIQDataColumn = (data) => {

        let totalGroupIQData = {
            runOfHouse: { available: 0, required: 0 },

            total: { available: 0, required: 0 }
        }
        columnNames.forEach(col => {
            if (!totalGroupIQData[col]) {
                totalGroupIQData[col] = { available: 0, required: 0 };
            }
        })
        data.forEach(entry => {

            columnNames.forEach(col => {

                totalGroupIQData[col].available += entry[col].available;
                totalGroupIQData[col].required += entry[col].required;
            })

            totalGroupIQData.total.available += entry.total.available;
            totalGroupIQData.total.required += entry.total.required;
        });
        return totalGroupIQData;
    };
    const calculateTotalGroupIQDataRow = (data) => {
        let returnData = data.map(entry => {
            const totalAvailable = entry.runOfHouse.available;
            let totalRequired = 0;
            columnNames.forEach(col => {
                totalRequired += entry[col].required;
            })
            entry.total = {
                available: Number(totalAvailable),
                required: Number(totalRequired),
                vcap: entry.runOfHouse.vcap,
                vcapLabel: entry.runOfHouse.vcapLabel,
                vcapDiffers: entry.runOfHouse.vcapDiffers,
            }
            return deepCopy(entry);
        });
        return returnData;
    };

    // Hotel-level capacity: use VCapacity when the toggle is on, else the normal Capacity.
    // Falls back to Capacity if VCapacity is missing.
    const getHotelCapacity = (primary) =>
        variableCapacityEnabled ? (primary.VCapacity || primary.Capacity) : primary.Capacity;

    // Room-type-level capacity: same idea, using VCapacityRt vs. the room's configured inventory.
    const getRoomTypeCapacity = (segmentPrimary, room) =>
        variableCapacityEnabled ? (segmentPrimary.VCapacityRt || room.inventory) : room.inventory;

    // Metadata for the VCapIndicator: only flags as "differs" when variable capacity is on
    // and actually diverges from the base capacity for that cell.
    const getVCapMeta = (baseCapacity, vCapacity) => ({
        vcap: variableCapacityEnabled ? (vCapacity || baseCapacity) : undefined,
        vcapLabel: (variableCapacityEnabled && vCapacity) ? 'Variable Capacity' : 'Capacity',
        vcapDiffers: !!(variableCapacityEnabled && vCapacity && vCapacity !== baseCapacity),
    });

    const setupRoomblockData = () => {
        gridRef.current.dataSource = [];
        if (otbRmType.length && 
            moment(otbRmType[0].index.date).format("YYYY-MM-DD") === moment(arrivalDate).format("YYYY-MM-DD") &&
            moment(otbRmType[otbRmType.length -1].index.date).add(1, 'days').format("YYYY-MM-DD") == moment(departureDate).format("YYYY-MM-DD")
        ){

            let date = moment(arrivalDate).format("YYYY-MM-DD");
            let numDays = dateDiff(departureDate, arrivalDate);
            const roomblockDataArr = [];
            for (let index = 0; index < numDays; index++) {

                const dataPoint = {
                    stayDates: {},
                    runOfHouse: { available: 0, required: 0 },
                    total: { available: 0, required: 0 }
                };
                dataPoint.stayDates = { date: date, dow: moment(date).format("ddd") };
                let dateData = otbRmType.find(i => {
                    if (moment(i.index.date).diff(date, 'days') == 0) {

                        return i;
                    }
                });
                if (dateData?.HotelTotal?.primary) {
                    let primary = dateData.HotelTotal.primary;
                    let capacity = getHotelCapacity(primary);
                    let available = capacity - primary.Rooms;
                    dataPoint.runOfHouse = { available, required: 0, ...getVCapMeta(primary.Capacity, primary.VCapacity) }
                }
                columnNames.forEach(col => {
                    if (!dataPoint[col]) {
                        dataPoint[col] = { available: 0, required: 0 };
                        if (dateData && dateData["Segment_" + col]?.primary) {
                            let room = room_settings.find(rm => rm.room_code === col);
                            let segmentPrimary = dateData["Segment_" + col].primary;
                            let capacity = getRoomTypeCapacity(segmentPrimary, room);
                            let available = capacity - segmentPrimary.Rooms;
                            dataPoint[col] = { available, required: 0, ...getVCapMeta(room.inventory, segmentPrimary.VCapacityRt) }
                        }
                    }
                    dataPoint.total.available += dataPoint[col].available;
                })
                roomblockDataArr.push(dataPoint);
                date = moment(date).add(1, 'days').format("YYYY-MM-DD");
            }
            const updatedGroupIQData = calculateTotalGroupIQDataRow(roomblockDataArr);
            const totalGroupIQData = calculateTotalGroupIQDataColumn(updatedGroupIQData);
            const lastRow = updatedGroupIQData[roomblockDataArr.length - 1];
            if (lastRow.stayDates === undefined) {
                updatedGroupIQData.pop();
            }
            updatedGroupIQData.push(totalGroupIQData);

            bindData(updatedGroupIQData);
        }

    }
    const bindData = (roomblockDataArr) => {
        const newDataFields = [
            { name: 'date', map: 'stayDates.date', dataType: 'string' },
            { name: 'dow', map: 'stayDates.dow', dataType: 'string' },
            { name: 'total-available', map: 'total.available', dataType: 'string' },
            { name: 'total-required', map: 'total.required', dataType: 'string' },
            { name: 'total-vcap', map: 'total.vcap', dataType: 'number' },
            { name: 'total-vcapLabel', map: 'total.vcapLabel', dataType: 'string' },
            { name: 'total-vcapDiffers', map: 'total.vcapDiffers', dataType: 'boolean' },
        ];
        columnNames.forEach(col => {
            newDataFields.splice(newDataFields.length - 6, 0, { name: col + '-available', map: col + '.available', dataType: 'string' });
            newDataFields.splice(newDataFields.length - 6, 0, { name: col + '-required', map: col + '.required', dataType: 'string' })
            newDataFields.splice(newDataFields.length - 6, 0, { name: col + '-vcap', map: col + '.vcap', dataType: 'number' });
            newDataFields.splice(newDataFields.length - 6, 0, { name: col + '-vcapLabel', map: col + '.vcapLabel', dataType: 'string' });
            newDataFields.splice(newDataFields.length - 6, 0, { name: col + '-vcapDiffers', map: col + '.vcapDiffers', dataType: 'boolean' });
        })

        gridRef.current.dataSource = new Smart.DataAdapter({
            dataSource: [...roomblockDataArr],
            dataFields: [...newDataFields],
        });
        groupIQNew.current = [...roomblockDataArr]
    }


    //handle input copy
    const handleCopy = (event) => {
        const lastColumnIndex = event.detail.cell.grid.columns.length - 1;
        const lastRowIndex = event.detail.cell.grid.rows.length - 1;
        const columnId = event.detail.column.dataField;
        const rowIndex = event.detail.row.id;
        const lastColumnId = event.detail.cell.grid.viewColumns[lastColumnIndex].dataField;
        const availableColumnId = event.detail.column.parent.columns[0].dataField;

        let value = Number(event.detail.cell.value);
        let columnTotal = 0;
        let grandTotal = 0;

        let gridDataSource = deepCopy(gridRef.current.dataSource);

        for (let i = 0; i < lastRowIndex; i++) {
            value = Number(event.detail.cell.value);
            const availableValue = parseInt(gridDataSource[i][availableColumnId]);
            value = availableValue >= value ? value : availableValue;
            value = value < 0 ? 0 : value;

            let oldCellValue = Number(gridDataSource[i][columnId]);
            let oldRowTotal = Number(gridDataSource[i][lastColumnId]);
            let newRowTotal = oldRowTotal;

            let totalAvailable = parseInt(gridRef.current.dataSource[i]["total-available"]);
            let totalRequired = parseInt(gridRef.current.dataSource[i]["total-required"]);
            let balanceRequired = totalAvailable - totalRequired + oldCellValue;

            let val = Math.min(balanceRequired, availableValue, value);
            val = val < 0 ? 0 : val;

            if (i > rowIndex) {
                gridDataSource[i][columnId] = Number(val);

                newRowTotal = newRowTotal - oldCellValue;
                newRowTotal = newRowTotal + Number(val);
                gridDataSource[i][lastColumnId] = newRowTotal;
            }
            columnTotal += Number(gridDataSource[i][columnId]);
            grandTotal += Number(gridDataSource[i][lastColumnId]);

        }
        gridDataSource[lastRowIndex][columnId] = columnTotal;
        gridDataSource[lastRowIndex][lastColumnId] = grandTotal;
        gridRef.current.dataSource = deepCopy(gridDataSource);
        gridDataSource = [];
        setTimeout(() => {
            handleScrollToEnd();
        }, 0);
    };

    const editing = {
        enabled: true,
        mode: 'cell'
    };
    const selection = {
        enabled: true,
        allowCellSelection: true,
        mode: 'one',
    };
    const behavior = {
        columnResizeMode: 'growAndShrink'
    };
    const appearance = {
        alternationCount: 2,
        showColumnHeaderLines: false,
        showColumnLines: false,
        showRowLines: false,
    };
    const onRowInit = (index, row) => {
        if (index === gridRef.current.dataSource.length - 1) {
            row.freeze = 'far';
        }
    }
    //Smart Grid params functions Ends

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleCheckboxChange = (groupName) => {
        // Prevent unchecking if there's only one selected group
        if (selectedGroups.length === 3 && selectedGroups.includes(groupName)) {
            console.log("Cannot uncheck the last selected group");
            return;  // Do nothing if there's only one selected group
        }

        if (selectedGroups.includes(groupName)) {
            removeColumnGroup(groupName)
        } else {
            addSelectedColumnGroups(groupName)
        }
    };

    const addSelectedColumnGroups = (groupName) => {
        const newColumnA = new Smart.Grid.Column({
            label: 'Available',
            labelTemplate: `<div id="secondary-header">
                Available
                ${variableCapacityEnabled && variableCapacityEnabled === true ? '<div class="variable-capacity">•OOO/OOS</div>' : ''}
            </div>`,
            dataField: `${groupName}-available`,
            columnGroup: groupName,
            allowEdit: false,
            minWidth: 120,
            template: availableWithVCapTemplate(variableCapacityEnabled),
        });
        gridRef.current.columns.push(newColumnA);

        const newColumnR = new Smart.Grid.Column({
            label: 'Required',
            dataField: `${groupName}-required`,
            columnGroup: groupName,
            minWidth: 120,
            labelTemplate: '<div id="secondary-header">Required</div>',
            template: requiredColTemplate('cell-right-border'),
        });
        gridRef.current.columns.push(newColumnR);

        let label = (groupName === "runOfHouse") ? "Run of House" : groupName;
        columnGroupsNew.current.push({ label: label, name: groupName })
        columnsNew.current = gridRef.current.getColumns();

        let columnId = 'required';
        let gridDataSource = deepCopy(gridRef.current.dataSource);
        gridDataSource.forEach((row, index) => {
            gridDataSource[index][`${groupName}-${columnId}`] = 0;
        })
        gridRef.current.dataSource = deepCopy(gridDataSource);
        gridDataSource = [];
        setSelectedGroups(prevState => [...prevState, groupName]);
        callCollectTabData();
    };

    const closeRoomTypeDropdown = () => {
        setDropdownVisible(false);
        setTimeout(() => {
            handleScrollToEnd();
        }, 0);
    }

    const removeColumnGroup = (groupName) => {
        let columnId = 'required';
        let grandTotal = 0;
        let gridDataSource = deepCopy(gridRef.current.dataSource);
        gridDataSource.forEach((row, index) => {
            let rowTotal = Number(gridDataSource[index][`total-${columnId}`]);
            let cellValue = Number(gridDataSource[index][`${groupName}-${columnId}`]);
            rowTotal = rowTotal - cellValue;
            grandTotal = grandTotal + rowTotal;
            gridDataSource[index][`total-${columnId}`] = rowTotal;
        })
        gridRef.current.dataSource = deepCopy(gridDataSource);
        gridDataSource = [];

        let columns = deepCopy(gridRef.current.getColumns());
        let colIndex = columns.findIndex(i => i.columnGroup === groupName);
        gridRef.current.columns.splice(colIndex, 2);
        columnsNew.current = gridRef.current.getColumns();

        let indexToDelete = columnGroupsNew.current.findIndex(i => i.name === groupName);
        gridRef.current.columnGroups.splice(indexToDelete, 1);
        columnGroupsNew.current.splice(indexToDelete, 1);

        let selectedGroupsNew = selectedGroups.filter(name => name !== groupName);
        setSelectedGroups(columnGroupsNew.current.map(i => i.name));
        callCollectTabData();

    };

    const updateRevModifier = (e, key) => {
        setRevenueModifier(prev => {
            prev[key] = key === "commission" ? convertToPercent(e.target.value, 'int') : e.target.value;
            return { ...prev };
        })
        callCollectTabData();
    }

    const callCollectTabData = () => {
        collectTabData({ dataSource: gridRef.current.dataSource, columnObjs: columnsNew.current, columnGroupObjs: columnGroupsNew.current, footerField: revenueModifier });
    }

    const onCellUpdate = (cells, oldValues, values, confirm) => {

        const lastColumnIndex = cells[0].grid.columns.length - 1;
        const lastRowIndex = cells[0].grid.rows.length - 1;
        const columnId = cells[0].column.dataField;
        const rowIndex = cells[0].row.id;
        const lastColumnId = cells[0].grid.viewColumns[lastColumnIndex].dataField;
        const availableColumnId = cells[0].column.parent.columns[0].dataField;
        const availableValue = parseInt(gridRef.current.dataSource[rowIndex][availableColumnId]);
        const oldCellValue = isNaN(parseInt(oldValues[0])) ? 0 : parseInt(oldValues[0]);
        let newValue = isNaN(parseInt(values[0])) ? 0 : parseInt(values[0]);

        if (isNaN(values) ||
            rowIndex === lastRowIndex ||
            newValue > availableValue ||
            newValue < 0) {
            confirm(false);
        }
        else {
            let gridDataSource = gridRef.current.dataSource;
            //Column Total
            let totalCellValue = parseInt(gridDataSource[lastRowIndex][columnId]);
            totalCellValue = totalCellValue - oldCellValue;
            let finalTotalValue = totalCellValue + newValue;
            gridDataSource[lastRowIndex][columnId] = finalTotalValue;

            //Row Total
            let rowTotalCellValue = parseInt(gridDataSource[rowIndex][lastColumnId]);
            rowTotalCellValue = rowTotalCellValue - oldCellValue;
            let rowFinalTotalValue = rowTotalCellValue + newValue;
            gridDataSource[rowIndex][lastColumnId] = rowFinalTotalValue;

            //Grand Total
            let grandTotalCellValue = parseInt(gridDataSource[lastRowIndex][lastColumnId]);
            grandTotalCellValue = grandTotalCellValue - oldCellValue;
            let grandFinalTotalValue = grandTotalCellValue + newValue;
            gridDataSource[lastRowIndex][lastColumnId] = grandFinalTotalValue;

            gridRef.current.dataSource = gridDataSource;
            gridDataSource = [];
            confirm(true);
            callCollectTabData();
        }
        handleScrollToEnd();
    }

    let clickElementEvent;
    let editCellEvent;
    const onBeginEdit = (event) => {
        editCellEvent = event;
        if (clickElementEvent && clickElementEvent.detail.originalEvent.target.classList.contains('note-icon-span')) {
            handleClick(clickElementEvent.detail.originalEvent, event.detail.data.date);
        }

        if (clickElementEvent && clickElementEvent.detail.originalEvent.target.classList.contains('event-icon-span')) {
            handleClick(clickElementEvent.detail.originalEvent, event.detail.data.date);
        }

        if (clickElementEvent && clickElementEvent.detail.originalEvent.target.classList.contains('copy-btn')) {
            handleCopy(event);
            event.preventDefault();
        }
        if ((gridRef.current.dataSource.length - 1) === event.detail.row.id) {
            event.preventDefault();
        }
    }
    const onCellClick = (event) => {
        clickElementEvent = event;

        // The Available column has allowEdit:false, so the grid's onBeginEdit event
        // (which note-icon-span/event-icon-span rely on) doesn't reliably fire for it -
        // it's gated behind the grid successfully starting a cell edit. onCellClick fires
        // unconditionally on every click, so the vcap indicator hooks in here instead.
        if (event.detail.originalEvent.target.classList.contains('vcap-indicator-span')) {
            handleClick(event.detail.originalEvent);
        }
    }
    const onKey = (event) => {
        const { column, id } = editCellEvent.detail;
        const availableColumnId = column.parent.columns[0].dataField;
        const availableValue = parseInt(gridRef.current.dataSource[id][availableColumnId]);
        const value = parseInt(event.target.value) ? parseInt(event.target.value) : 0;
        const oldValue = isNaN(parseInt(editCellEvent.detail.value)) ? 0 : parseInt(editCellEvent.detail.value);

        let totalAvailable = parseInt(gridRef.current.dataSource[id]["total-available"]);
        let totalRequired = parseInt(gridRef.current.dataSource[id]["total-required"]);
        let balanceRequired = totalAvailable - totalRequired + oldValue;

        let val = Math.min(balanceRequired, availableValue, value);
        if (value > val) {
            event.target.value = val;
            event.preventDefault();
        }

    }

    const dropdownRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeRoomTypeDropdown();
            }
        }

        if (dropdownVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownVisible, closeRoomTypeDropdown]);

    const handleClick = (event, dateValue) => {
        // vcap-indicator-span is routed here from onCellClick (see above), not onBeginEdit,
        // so it needs its own branch: flushSync forces the <VCapIndicator/> mount (triggered
        // by setAnchorEl below) to commit before we synthetically click its inner marker,
        // otherwise that marker wouldn't exist in the DOM yet on the click that mounts it.
        if (event.target.className === 'vcap-indicator-span') {
            vcapDataRef.current = {
                vcap: Number(event.target.dataset.vcap),
                vcapLabel: event.target.dataset.vcapLabel,
                date: event.target.dataset.date,
            };
            flushSync(() => setAnchorEl(event));
            document.querySelector('[data-testid="vcap-indicator"]')?.click();
            return;
        }

        dateValueRef.current = dateValue;
        setAnchorEl(event);

        if (event.target.className === 'note-icon-span') {
            let noteIconDiv = document.getElementsByClassName('note-icon-div');
            noteIconDiv[0].click();
        }

        if (event.target.className === 'event-icon-span') {
            let noteIconDiv = document.getElementsByClassName('event-icon-div');
            noteIconDiv[0].click();
        }

    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'outerPopupCover' : undefined;


    const threshold = useRef(4);
    useEffect(() => {
        threshold.current = getColumnThreshold()
    }, [arrivalDate, departureDate, otbRmType, columnGroupsNew.current]);

    const getColumnThreshold = () => {
        const height = window.innerHeight;
        if (height <= 1000) {
            return 4;
        } else if (height > 1000) {
            return 7
        } else if (height >= 1200) {
            return 10
        }
    };

    const handleScrollToEnd = () => {
        if (gridRef.current) {
            const maxScroll = gridRef.current.getHorizontalScrollMax();
            const currentScroll = gridRef.current.getHorizontalScrollValue();
            const scrollDiff = maxScroll - currentScroll;
            if (scrollDiff < 18 ){
                gridRef.current.setHorizontalScrollValue(maxScroll)
            }
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            //height:'auto',
            height: `${gridHeight}px`,
            overflow: 'hidden',
        }}>
            {dropdownVisible && (
                <div className="dropdown-room-type-selection" ref={dropdownRef}>
                    <svg className="indicator" xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 256 256"><path d="M207.39,123.06A8,8,0,0,1,200,128H56a8,8,0,0,1-5.66-13.66l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,207.39,123.06Z"></path></svg>
                    <div className='room-type-list'>
                        {removableColumnGroups.map(group => (
                            <div key={group.name} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Checkbox
                                    id={group.label}
                                    className="checkbox"
                                    checked={selectedGroups.includes(group.name)}
                                    onChange={() => handleCheckboxChange(group.name)}
                                ></Checkbox>
                                <label for={group.label}>{group.label}</label>
                            </div>
                        ))}
                    </div>
                    <div className='done-btn'>
                        <button className="filter-button primary" onClick={closeRoomTypeDropdown}>Done</button>
                    </div>
                </div>
            )}

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                anchorReference="anchorPosition"
                anchorPosition={anchorEl && { top: anchorEl.clientY, left: anchorEl.clientX }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                className='outer-popup-cover'
                style={{ opacity: 0, visibility: 'hidden' }}
            >

                {anchorEl && anchorEl.target.className === 'note-icon-span' && <NotesPopup params={{ stay_date: dateValueRef.current, readonly: true }} outerHandleClose={handleClose} />}
                {anchorEl && anchorEl.target.className === 'event-icon-span' && <EventsPopup params={{ stay_date: dateValueRef.current }} outerHandleClose={handleClose} />}
                {anchorEl && anchorEl.target.className === 'vcap-indicator-span' && (
                    <VCapIndicator
                        vcap={vcapDataRef.current?.vcap}
                        vcapLabel={vcapDataRef.current?.vcapLabel}
                        vcapDiffers={true}
                        variableCapacityEnabled={variableCapacityEnabled}
                        date={vcapDataRef.current?.date}
                    />
                )}
            </Popover>
            <Grid
                style={{ flexGrow: 1 }}
                // dataSource={dataSource}
                columns={columnsNew.current}
                ref={gridRef}
                //columnGroups={columnGroups}
                columnGroups={columnGroupsNew.current.map((group, index) => {
                    const removableGroupsShown = columnGroupsNew.current.filter(cg => removableColumnGroups.some(remGroup => {
                        if (remGroup.name === cg.name) {
                            return cg;
                        }
                    }));
                    group.labelTemplate = `
                            <div id="primary-header" style="${removableColumnGroups.some(remGroup => remGroup.name === group.name) ? 'display: grid; grid-template-columns: auto 50px; align-items: center;' : ''}">
                                <div style="${removableColumnGroups.some(remGroup => remGroup.name === group.name) ? 'margin-left: 48px' : ''}">${group.label}</div>
                                <div class="add-remove-column-icon-container">
                                    ${removableGroupsShown.length > 1 && removableColumnGroups.some(remGroup => remGroup.name === group.name)
                            ? `<svg class="add-remove-column-icon" onclick="document.dispatchEvent(new CustomEvent('removeColumnGroup', { detail: '${group.name}' }))" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#fff" viewBox="0 0 256 256"><path d="M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path></svg>`
                            : ''}
                                    ${index === columnGroupsNew.current.length - 1 && removableColumnGroups.some(remGroup => remGroup.name === group.name)
                            ? `<svg style="transform: ${dropdownVisible ? 'rotate(45deg)' : 'rotate(0deg)'}; transition: transform 0.3s ease-in-out;" class="add-remove-column-icon" onclick="document.dispatchEvent(new CustomEvent('openDropdown'))" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#fff" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"></path></svg>`
                            : ''}
                                </div>
                            </div>    
                        `
                    return group
                })}
                editing={editing}
                behavior={behavior}
                appearance={appearance}
                onRowInit={onRowInit}
                selection={selection}
                onCellUpdate={onCellUpdate}
                onBeginEdit={onBeginEdit}
                className={columnGroupsNew.current.length < threshold.current ? 'room-block-grid no-scrollable' : 'room-block-grid'}
                onCellClick={onCellClick}
                onKeyUp={onKey}
            ></Grid>
            <div className="room-block-bottom">
                <div className="left-bottom-data">
                    <label for="complimentaryRooms">Complimentary Rooms: <span className="value-box"><input id="complimentaryRooms" type="number" defaultValue={revenueModifier.complimentaryRooms && revenueModifier.complimentaryRooms} onBlur={(e) => { updateRevModifier(e, "complimentaryRooms") }} /> <span className="light">ROH</span></span></label>
                    <label for="perPadeRooms">Per Paid Rooms: <span className="value-box"><input id="perPadeRooms" type="number" defaultValue={revenueModifier.perPadeRooms && revenueModifier.perPadeRooms} onBlur={(e) => { updateRevModifier(e, "perPadeRooms") }} /></span></label>
                    <label for="commission">Commission: <span className="value-box"><input id="commission" type="number" defaultValue={revenueModifier.commission && convertToPercent(revenueModifier.commission)} onBlur={(e) => { updateRevModifier(e, "commission") }} />%</span></label>
                </div>
                <div></div>
            </div>
        </div>
    )
}

export default RoomBlock
